import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SideMenu from "../../Components/SideMenu";
import { Button, Col, Row } from "react-bootstrap";
import {
  addQuickReply,
  getFrontEndBranch,
  getQuickReply,
  updateQuickReply,
} from "../../reducers/commonReducer";
import { home } from "../../const";
import QuickReplyAction from "./QuickReplyAction";
import moment from "moment";

const QuickReply = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isTeamLeader = localStorage.getItem("slug") === "team_leader";

  useEffect(() => {
    if (!localStorage.getItem("x-auth-token")) {
      navigate(home);
    }
    dispatch(getQuickReply());
    if (!isTeamLeader) {
      dispatch(getFrontEndBranch());
    }
  }, [dispatch, isTeamLeader, navigate]);

  const { quickReplyList } = useSelector((state) => state.commonReducer);
  return (
    <>
      <SideMenu />
      <div className="mt-extra content container-fluid">
        <Row className="mt-1 mb-2">
          <Col md={4}>
            <QuickReplyAction
              buttonTitle="Quick Reply"
              popupTitle={"Add Quick Reply"}
              api={addQuickReply}
            />
          </Col>
        </Row>
        <table className="table w-100">
          <thead className="normalplace">
            <tr>
              <th className="over-col-size">Sr</th>
              <th className="over-col-size">Date</th>
              <th className="over-col-size">Title</th>
              <th className="over-col-size">Question</th>
              <th className="over-col-size">Content</th>
              <th className="over-col-size">Upload</th>
              <th className="over-col-size">QrderBy</th>
              {!isTeamLeader && <th className="over-col-size">Branch</th>}
              <th className="over-col-size">Status</th>
              <th className="over-col-size">Action</th>
            </tr>
          </thead>
          <tbody>
            {!!quickReplyList &&
              quickReplyList
                ?.filter((data) => data?.messageType !== "sticker")
                ?.map((data, index) => {
                return (
                  <React.Fragment key={index}>
                    <tr key={index}>
                      <td>{index + 1}.</td>
                      <td>{moment(data?.createdAt).format("YYYY-MM-DD")}</td>
                      <td>{data?.title}</td>
                      <td>{data?.question !== "undefined" && data?.question}</td>
                      <td>{data?.content}</td>
                      
                      <td>{data?.messageType}</td>
                      <td>{data?.orderBy}</td>
                      {!isTeamLeader && (
                        <td>
                          {data?.branch?.map((branch, branchIndex) => (
                            <Button
                              className="p-1 bg-thememain text-black m-1"
                              key={branchIndex}
                            >
                              {branch?.name}
                            </Button>
                          ))}
                        </td>
                      )}
                      <td>
                        <b>
                          {data?.status ? (
                            <span className="text-success">Active</span>
                          ) : (
                            <span className="text-danger">InActive</span>
                          )}
                        </b>
                      </td>
                      <td>
                        <div className="d-flex">
                          <QuickReplyAction
                            api={updateQuickReply}
                            popupTitle={"Update Quick Reply"}
                            title={data?.title}
                            question={data?.question}
                            messageType={data?.messageType}
                            content={data?.content}
                            orderBy={data?.orderBy}
                            branch={data?.branch}
                            files={data?.files}
                            status={data?.status}
                            id={data?.id}
                          />
                          <Button
                            variant="danger"
                            className="m-1"
                            onClick={async () => {
                              const confirmDelete = window.confirm(
                                "Are you sure you want to delete this?"
                              );
                              if (confirmDelete) {
                                const apiResp = await dispatch(
                                  updateQuickReply({
                                    id: data?.id,
                                    softDelete: true,
                                  })
                                );

                                if (apiResp?.payload?.status) {
                                  dispatch(getQuickReply());
                                }
                              }
                            }}
                          >
                            <i className="bi bi-trash3"></i>
                          </Button>
                        </div>
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default QuickReply;
